// Brand: Milano

import React from "react";
import withAppState from "../mobx/withAppState";
import { Steps, GetStepName } from "../lib/constants";
import TopBanner from "../components/TopBanner";
import ErrorModal from "../components/ErrorModal";
import Modal from "../components/Modal";
import MenuFooter from "../components/MenuFooter";
import Rotate from "../components/Rotate";
import Legal from "../components/Legal";
import Footer from "../components/Footer";
import Header from "../components/Header";
import MenuFooterLinks from '../components/MenuFooterLinks';
import Flow from "./Milano/PayAtTable";
import "../styles/PizzaExpress/App.css";
import "../styles/PizzaExpress/TopBanner.css";
import "../styles/PizzaExpress/Menu.css";
import milogo from "../assets/milano/milano-logo-header.svg";
import TagManager from "react-gtm-module";
import Cookies from "js-cookie";
import twitterIcon from '../assets/img/icons/twitter.svg';
import instagramIcon from '../assets/img/icons/instagram.svg';
import facebookIcon from '../assets/img/icons/facebook.svg';
import deliveryMan from '../assets/img/deliveryMan.svg';



const uuidv4 = require("uuid/v4");

class Milano extends React.Component {
  constructor() {
    super();
    this.state = {
      acceptCookieSet: false,
    };
  }

  getRestaurantNameFromUrl = () => {
    var pathName = window.location.pathname.substr(1);
    var pathArray = pathName.split('/');

    if (!pathArray || pathArray[0].toLowerCase() == 'restaurant-menu' || pathArray[0] == '') {
      return null;
    }
    return pathArray[0];
  }

  async componentDidMount() {
    document.title = "Menu | Milano";
    let culture = { symbol: "€", language: "en-IE", currency: "EUR" };
    this.props.setCurrency(culture);
    this.props.setCanSignup(false);
    this.props.setHasSocialLinks(false);
    this.props.setComanyName("Milano");
    this.props.setApplySoftOtIn(false);
    this.props.setReturnHref("https://milano.ie/");
    const urlParams = new URLSearchParams(window.location.search);
    var isOrder = urlParams.get("order");
    var isCheckIn = urlParams.get("checkin");
    var isMenu = window.location.pathname.includes('restaurant-menu/main-menu');
    this.props.setIsOrderJourney(isOrder !== null || isCheckIn !== null || isMenu);
    this.props.setIsCheckInJourney(isCheckIn !== null);
    let splitBillSessionToken = Cookies.get("SPLIT_BILL_SESSION_TOKEN");

    var restaurantNameFromUrl = this.getRestaurantNameFromUrl();

    this.setState({ acceptCookieSet: this.props.hasAcceptedCookies() });

    const response = await fetch(`api/Setup`);

    let restaurant = null;

    if (restaurantNameFromUrl != null) {
      
      try {
        this.props.firstLoadLocalMenu(true);
        restaurant = await fetch(`api/Restaurant/GetSingleRestaurantFromVanityName/${restaurantNameFromUrl}`);        
        const restaurantData = await restaurant.json();  
        this.props.selectRestaurant(restaurantData);
        this.props.goToStepWithoutHistory(Steps.PRE_ORDER);
      } catch(error){
        console.error({error});
      }
    }

    if (response.status === 200) {
      let data;
      try {
        data = await response.json();
        const gtmId = data.googleTagManagerId;
        if (gtmId) {
          TagManager.initialize({
            gtmId,
            dataLayerName: "dataLayer",
          });
        }
      } catch (err) { }
    }

    if (splitBillSessionToken == null) {
      var uuid = uuidv4();
      Cookies.set("SPLIT_BILL_SESSION_TOKEN", uuid, { expires: 90, path: "" });
      this.props.setSplitBillSessionToken(uuid);
    } else {
      this.props.setSplitBillSessionToken(splitBillSessionToken);
    }
  }

  render() {
    const { activeStep, submittingPayment, isOrderJourney } = this.props;
    var footerMargin =
      (activeStep === Steps.BILL ||
        activeStep === Steps.APPLY_GRATUITY ||
        activeStep === Steps.PAY ||
        activeStep === Steps.REGISTER) &&
      submittingPayment === false;

    var menuJourneyHeader =
      isOrderJourney &&
      (this.props.activeStep === Steps.DEFAULT ||
        this.props.activeStep === Steps.PRE_ORDER ||
        this.props.activeStep === Steps.PRE_ORDER_DATA_CAPTURE);

    const pageName = GetStepName(this.props.activeStep);
    var tagManagerArgs = {};

    if(this.props.activeStep === Steps.TABLE_PICKER)
    {
      tagManagerArgs = {
        dataLayer: {
          restaurantId: this.props.restaurant?.id,
          tableNumber: this.props.tableNumber,
          page: pageName
        },
        dataLayerName: "dataLayer",
      };
    }
    else{
      tagManagerArgs = {
        dataLayer: {
          //restaurantId: this.props.restaurant?.id,
          //tableNumber: this.props.tableNumber,
          page: pageName
        },
        dataLayerName: "dataLayer",
      };
    }
    
    TagManager.dataLayer(tagManagerArgs);
    if (!window.sessioncamConfiguration)
      window.sessioncamConfiguration = new Object();

    window.sessioncamConfiguration.SessionCamPath = "";
    window.sessioncamConfiguration.SessionCamPageName = pageName;

    return (
      <div className="app-wrapper branded">
        
        <div className="app">
          <div
            className={`app-container menu ${footerMargin ? "footer-margin" : ""
              }${menuJourneyHeader ? "menu" : ""}`}
          >
            <div>
              <div className="menu-page home">
                
                <div>
                  <Legal
                    enabled={!!this.props.privacyPolicyAndTermsConditionsModal}
                    isOrderJourney={this.props.isOrderJourney}
                    brandTermConditions={false}
                  />
                      {menuJourneyHeader === true 
                          ? (<React.Fragment></React.Fragment>)
                          : (
                            <>
                              <Header logo={<img src={milogo} alt="Milano" />} />                            
                            </>
                          )}
                          <>
                        {menuJourneyHeader === true 
                            ? (<React.Fragment></React.Fragment>)
                            : (
                              <>
                              
                                  <div className="home-card-intro">
                                    <div className="home-card-intro-inner">
                                      <TopBanner logo={<img src={milogo} alt="Milano" />} />
                                      <Modal enabled={!!this.props.modalActive} />
                                    </div>
                                    <ErrorModal enabled={!!this.props.errorModalMessage} />
                                  </div>
                              </>
                            )}
                        <Flow />
                          </>
                </div>  
                {menuJourneyHeader === true ? 
                  null : <>                
                          <Footer innerWrapper={true} />
                          <MenuFooter
                              brand={"Milano"}
                              hasMarginTop={false}
                            >
                            <MenuFooterLinks />
                          </MenuFooter>
                        </>
                }                           
                                       
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppState(Milano, {
  mobXProps: ({
    sourceIsApp,
    activeStep,
    submittingPayment,
    modalActive,
    errorModalMessage,
    privacyPolicyAndTermsConditionsModal,
    isOrderJourney,
    tableNumber,
    restaurant,
    brandTermConditions,
  }) => ({
    sourceIsApp,
    activeStep,
    submittingPayment,
    modalActive,
    errorModalMessage,
    privacyPolicyAndTermsConditionsModal,
    isOrderJourney,
    tableNumber,
    restaurant,
    brandTermConditions,
  }),
  mobXActions: ({
    setSourceIsAppTrue,
    setAppPlatform,
    selectRestaurant,
    goToStepWithoutHistory,
    setSplitBillSessionToken,
    setIsOrderJourney,
    setCurrency,
    setCanSignup,
    setHasSocialLinks,
    setComanyName,
    setReturnHref,
    hasAcceptedCookies,
    setIsCheckInJourney,
    setApplySoftOtIn,
    firstLoadLocalMenu
  }) => ({
    setSourceIsAppTrue,
    setAppPlatform,
    selectRestaurant,
    goToStepWithoutHistory,
    setSplitBillSessionToken,
    setIsOrderJourney,
    setCurrency,
    setCanSignup,
    setHasSocialLinks,
    setComanyName,
    setReturnHref,
    hasAcceptedCookies,
    setIsCheckInJourney,
    setApplySoftOtIn,
    firstLoadLocalMenu
  }),
});
